import { render, staticRenderFns } from "./templatePage.vue?vue&type=template&id=7c863408&scoped=true&"
import script from "./templatePage.vue?vue&type=script&lang=js&"
export * from "./templatePage.vue?vue&type=script&lang=js&"
import style0 from "./templatePage.vue?vue&type=style&index=0&id=7c863408&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c863408",
  null
  
)

export default component.exports